<template>
  <div class="page_info_box">
    <!-- <van-tabs v-model="active">
      <van-tab title="公众号" name="wechat"></van-tab>
      <van-tab title="APP下载" name="app"></van-tab>
    </van-tabs> -->
    <van-image class="page_logo" :src="require('../assets/zzb-C.png')"></van-image>
    <!-- 公众号 -->
    <div class="button_box" v-if="active == 'wechat'">
      <img style="z-index: 20" id="gzhImage" class="gzh_go_img" src="../assets/gxh.jpg" alt="">
      <p class="page_text">长按图片前往关注公众号</p>
      <img :style="'opacity: 0.3'" class="page_bottom_img" src="../assets/page_background-button-C@2x.png" alt="">
    </div>
    <!-- app -->
    <!-- <div class="button_box" v-if="active == 'app'">
      <div v-if="appFlag == 20"  @click="getLatestVersion(20)">
        <van-image :src="require('../assets/icon-iOS-C@2x.png')"></van-image>
        <span>iPhone下载</span>
      </div>
      <div v-if="appFlag == 10"  @click="getLatestVersion(10)">
        <van-image :src="require('../assets/icon-Android-C@2x.png')"></van-image>
        <span>Android下载</span>
      </div>
      <img class="page_bottom_img" src="../assets/page_background-button-C@2x.png" alt="">
    </div> -->
    <!-- 遮罩 -->
    <van-overlay :show="show" @click="show">
      <img class="download-icon" src="@/assets/download.png" alt="">
      <p class="download-text">请在默认浏览器中打开下载！</p>
    </van-overlay>
  </div>
</template>

<script>
  import { getLatestVersionC } from '@/api/index'
  export default {
    data() {
      return {
        active: 'wechat',
        show: false,
        appFlag: this.isSystem() == 'ios' ? 20 : 10,
      }
    },
    created() {
      if(this.getUrlCode().active) {
        this.active = this.getUrlCode().active;
      }
    },
    methods: {
      // 截取url中的code方法
      getUrlCode() {
          var url = decodeURIComponent(location.search);
          this.winUrl = url;
          var theRequest = new Object();
          if (url.indexOf("?") != -1) {
              var str = url.substr(1);
              var strs = str.split("&");
              for (var i = 0; i < strs.length; i++) {
                  theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
              }
          }
          return theRequest;
      },
      // 判断
      weixin(){
        var ua = window.navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger'){
          return true
        } else {
          return false
        }
      },
      // 下载内容
      getLatestVersion(data){
        let isSystemType = this.isSystem() == 'ios' ? 'ios' : 'Android';
        if(data != this.appFlag){
          this.$dialog.alert({
            message: '您当前的机型为'+ isSystemType +',请下载对应版本！',
            className: 'dialogbox'
          }).then(() => {});
          return
        }
        getLatestVersionC({ clientType: data }).then(res => {
          this.$dialog.confirm({
              message: '确定要下载'+ isSystemType +'版本APP吗？',
              className: 'dialogbox'
            })
            .then(() => {
              window.location.href = res.data.releaseUrl;
              this.show = true;
            })
            .catch(() => {});
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
.van-tabs {
  width: 100%;
}
@mixin direction {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.page_info_box {
  width: 100vw;
  min-height: 100vh;
  background-image: url('../assets/page_background-C@2x.png'), linear-gradient(to right, #CE595E, #CE595E);
  background-size: 100% auto;
  background-repeat: no-repeat;
  @include direction;
  .page_bottom_img {
    width: 100%;
    height: 330px;
    position: absolute;
    bottom: 0;
  }
  .page_logo {
    width: 87px;
    margin: 31px 0 35px 0;
  }
}
.button_box {
  width: 100vw;
  @include direction;
  div {
    width: 173px;
    height: 36px;
    background: white;
    opacity: 1;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .van-image {
      width: 18px;
      height: 18px;
      margin-left: 35px;
    }
    span {
      font-size: 14px;
      font-weight: 500;
      color: #333333;
      margin-right: 30px;
    }
  }
}
.download-icon{
  position: absolute;
  right: 2vw;
  top: 2vh;
  width: 10vw;
}
.download-text{
  font-size: 16px;
  color: white;
  position: absolute;
  right: 2vw;
  top: 6vh;
}
.gzh_go_img {
  width: 40vw;
  padding: 2vw;
  background: white;
  border-radius: 3vw;
}
.page_text {
  font-weight: bold;
  font-size: 3.8vw;
  color: white;
  z-index: 20;
}
</style>